import PropTypes from "prop-types";
import {isEqual} from 'lodash'

import {useEventListener} from "../../../../Hooks/useEventListener";

const ShortcutListener = (props) => {
    const {component, doActions, target} = props;
    const {properties: {source} = {}, events} = component;

    function listener(e) {
        if (source) {
            const combKeys = {
                ctrlKey: e.ctrlKey,
                altKey: e.altKey,
                shiftKey: e.shiftKey,
                key: e.key
            }
            if (isEqual(combKeys, source)) {
                e.preventDefault();
                e.stopPropagation();
                doActions(events[0].actions)
            }
        }
    }

    useEventListener('keydown', listener, target)


    return <></>
}

export default ShortcutListener;

ShortcutListener.propTypes = {
    component: PropTypes.object,
    doActions: PropTypes.func
}